import { useTranslation } from 'next-i18next';
import React from 'react';
import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/libs.sx';
import { formatPrice } from '@hotelplan/libs.utils';
import { PriceFragment } from 'graphql/fragments/Price.generated';

interface IOfferPriceDescriptionProps {
  pricePerPerson: PriceFragment;
}

export const TooltipWrapper = styled.div(
  sx2CssThemeFn({
    position: 'relative',
    width: '113px',
    '.tooltip': {
      visibility: 'visible',
      zIndex: 2,
      left: '50%',
      transform: 'translateX(-50%)',
      bottom: 'calc(100% + 3px)',
      '&:after': {
        display: 'block',
      },
    },
    '.title': {
      background: 'none',
      p: '0',
      m: '0',
      color: 'secondary',
      fontSize: 1,
    },
    '.price': {
      fontSize: 1,
      fontWeight: '400',
      color: 'textGray',
    },
    '.tooltipArrow': {
      display: 'none',
    },
  })
);

const OfferPriceDescription = ({
  pricePerPerson,
}: IOfferPriceDescriptionProps) => {
  const [t] = useTranslation(['common', 'orl']);

  return (
    <>
      <h2 className="title">
        {t('common:pricePerPerson.title')}{' '}
        <span className="price">{formatPrice(pricePerPerson)}</span>
      </h2>
    </>
  );
};

export default OfferPriceDescription;
